
define(['underscore', 'moment', 'text!./templates/basler-collapsable-section.html'],
    (_, moment, templateStr) => {
        return ['StateUtils', (StateUtils) =>{ //NOSONAR
                return {
                    restrict: 'E',
                    transclude: true,
                    template: templateStr,
                    scope: {
                        headerImgSrc: '@',
                        headerImgClass: '@',
                        headingTitle: '@',
                        redirectState: '@',
                    },
                    controller: ['$scope', function ($scope) { //NOSONAR

                        $scope.collapsed = false;
                        this.collapsed = $scope.collapsed;
                        $scope.collapse = function () {
                            if ($scope.collapsed) {
                                $scope.collapsed = false;
                            } else {
                                $scope.collapsed = true;
                            }
                        };
                        
                        /*
                        * Using new FlowApi to redirect to page
                         */
                        $scope.redirectToState = function (stateName) {
                            const flowModel = StateUtils.activeDataForState(true).flowModel;
                            const steps = flowModel.steps;
                            const stepToJump = _.findWhere(steps, {name: stateName});

                            // We rely on a snapshot stored in the parent scope to jump to previous screen                            
                            flowModel.jumpToStep(stepToJump, $scope.$parent.submissionSnapshot, undefined, true);
                        };
                    }],
                };
            }];
    }
);


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerCollapsableSection.js